import { render, staticRenderFns } from "./total sales.vue?vue&type=template&id=78635a74"
import script from "./total sales.vue?vue&type=script&lang=js"
export * from "./total sales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports